import ElleStandaloneMemberOffers from '@/elle/components/MemberOffers';
import { LabradorComponent } from '@/types/component';
import { parseJSON } from '@/utils/parseJSON';

export const ElleLabradorMemberOffers: LabradorComponent = ({ type, data, meta, descendants }) => {
  return <ElleStandaloneMemberOffers title={data.infoText} offers={parseJSON(data.array, [])} />;
};

export default ElleLabradorMemberOffers;
